/**
 * Einstellungen › "Blockierte Absender (alt)" — the LEGACY per-user blocklist rules.
 *
 * P2 hardening 04 superseded the per-user hard block with "Private Absender" (PrivateSendersSection).
 * Pre-existing user-level email_blacklist_rules keep working at sync time; this section only LISTS
 * them (collapsed, read-only add) so a broker can still remove one. Renders NOTHING when the caller
 * has no legacy rules — no new blocks can be created here any more.
 */

import { Ban } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { dateShortDe } from '../../lib/format';
import { useMyBlocklist, useUnblockSender } from './useMyBlocklist';

export function MyBlocklistSection() {
  const { data: mine = [], isLoading } = useMyBlocklist();
  const unblock = useUnblockSender();

  // No legacy rules → render nothing (the feature moved to "Private Absender").
  if (isLoading || mine.length === 0) return null;

  return (
    <section aria-labelledby="my-blocklist-title" className="flex flex-col gap-3 rounded-lg border bg-card p-4">
      <div>
        <h2 id="my-blocklist-title" className="flex items-center gap-2 text-sm font-medium">
          <Ban className="size-4" /> Blockierte Absender (alt)
        </h2>
        <p className="mt-1 text-xs text-muted-foreground">
          Ältere, hart blockierte Absender. Neue Einträge legen Sie oben unter «Private Absender» an.
          Diese Regeln können Sie hier weiterhin aufheben.
        </p>
      </div>

      <ul className="flex flex-col divide-y divide-border rounded-md border">
        {mine.map((b) => (
          <li key={b.id} className="flex items-center gap-3 px-3 py-2 text-sm">
            <span className="min-w-0 flex-1 truncate text-foreground">{b.address}</span>
            <span className="text-xs text-muted-foreground">seit {dateShortDe(b.created_at)}</span>
            <Button
              size="sm"
              variant="outline"
              disabled={unblock.isPending}
              onClick={() => unblock.mutate(b.id)}
              aria-label={`Blockierung von ${b.address} aufheben`}
            >
              Blockierung aufheben
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
